import { Link, useNavigate } from "react-router-dom";
import style from "../style/layout.module.css";

import { Ideal, Share } from "./";
import { IoIosRefresh } from "react-icons/io";
import Popup from "./Popup";
import { useState } from "react";
import { useRecoilValue } from "recoil";
import { AtomScore } from "../store/store";
import ShareIdeal from "./ShareIdeal";
import EventAlarm from "./EventAlarm";
import Apply from "../pages/Apply";

export default function Result({ children, image, name, share, ability, id }) {
  const [toggle, setToggle] = useState(false);
  const navigator = useNavigate();
  const [completePopup, setCompletePopup] = useState(false);
  const idealScore = useRecoilValue(AtomScore);
  const amount = Object.values(idealScore).reduce((a, b) => a + b);
  const handlePopup = (type) => {
    if (amount < 30) return alert("모든 포인트를 분배해주세요.");
    if (type === "open") {
      setToggle(true);
    } else if (type === "close") {
      setToggle(false);
    }
  };

  const shareBtn = () => {
    if (amount < 30) return alert("모든 포인트를 분배해주세요.");
    const URL = new URLSearchParams();

    URL.append("image", image);
    URL.append("name", name);

    URL.append("height", idealScore.height);
    URL.append("job", idealScore.job);
    URL.append("economy", idealScore.economy);
    URL.append("degree", idealScore.degree);
    URL.append("family", idealScore.family);
    const query = URL.toString();
    // window.history.replaceState({}, "", `share?${query}`);
    // 공유하기 이벤트
    function shareMessage() {
      const kakao = window.Kakao;
      if (!kakao.isInitialized()) {
        kakao.init(process.env.REACT_APP_KAKAO_KEY); // 카카오에서 제공받은 javascript key를 넣어줌 -> .env파일에서 호출시킴
      }

      kakao.Share.sendDefault({
        objectType: "feed",
        content: {
          title: "[디에이블]이상형 월드컵 이벤트",
          description: "친구에게 공유하기를 통해 당첨 확률을 올려보세요!",

          imageUrl: `https://theableapp.kr${image}`,
          link: {
            // [내 애플리케이션] > [플랫폼] 에서 등록한 사이트 도메인과 일치해야 함
            mobileWebUrl: `https://theableapp.kr/worldcup/share?${query}`,
            webUrl: `https://theableapp.kr/worldcup/share?${query}`,
          },
        },

        buttons: [
          {
            title: "결과 확인하고 참여하기",
            link: {
              mobileWebUrl: `https://theableapp.kr/worldcup/share?${query}`,
              webUrl: `https://theableapp.kr/worldcup/share?${query}`,
            },
          },
        ],
      });
    }
    shareMessage();
  };
  const completePopupHanlder = (type) => {
    setCompletePopup(type);
  };
  return (
    <div className={style.result}>
      <h3 className={style.result_text}>최종 우승자</h3>
      {children}
      {share ? <ShareIdeal ability={ability} /> : <Ideal />}

      <div className={style.result_event}>
        {!share && <strong>위의 포인트를 분배해보세요!</strong>}
        <div className={style.result_btns}>
          <Link to="/" className={style.result_re}>
            <IoIosRefresh />
            다시하기
          </Link>
          {!share && <Share text="친구들에게 공유하기" handleBtn={shareBtn} />}
        </div>

        {/* {!share && (
          <>
            <Share
              handleBtn={() => handlePopup("open")}
              text="본인인증하고 경품응모하기!"
            />
            <EventAlarm />
          </>
        )} */}
      </div>

      {toggle && (
        <Popup
          handlePopup={handlePopup}
          image={image}
          name={name}
          id={id}
          completePopupHanlder={completePopupHanlder}
        />
      )}
      {!share && completePopup && (
        <Apply completePopupHanlder={completePopupHanlder} />
      )}
    </div>
  );
}
